import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  getAll: function (params) {
    return axios.get(`${window.apiURL}api/blog`, { params })
  },
  get: function (id) {
    return axios.get(`${window.apiURL}api/blog/${id}`)
  },
  getCategoryAndTotals: function () {
    return axios.get(`${window.apiURL}api/blog/category/totals`)
  },
  getPostByCategory: function (key, params) {
    return axios.get(`${window.apiURL}api/blog/category/${key}`, { params })
  },
  getAttraction: function () {
    return axios.get(`${window.apiURL}api/blog-attraction`)
  },
  getPublicInfo: function () {
    return axios.get(`${window.apiURL}api/public/info`)
  }
}



// WEBPACK FOOTER //
// ./src/services/blog.js